export default "__VITE_ASSET__hjGBcZ7t__"